// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetHeaderRequest, TGetHeaderModel, IMappers, TGetHeaderResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetHeaderResponse } from '../../entities/response/V1GetHeaderResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHeaderModel(parameters: IGetHeaderRequest): TGetHeaderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'header',
    pathApi: '/v1/get-header/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetHeaderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetHeaderRequest;
}

export async function fetchGetHeader<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHeaderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHeaderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHeaderModel(parameters),
    config,
  )) as FetchResponse<TGetHeaderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetHeaderResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHeaderResponse>;
}
